import { initProductSelection, initStepGating } from './shared.js';
import initSelect2 from '../helpers/select2.js';
import { addNewPrototype, getPrrcInfo, updateOptionsSelect2 } from '../helpers/helper.js';

const initCapaReportForm = () => {
	const affectsEl = $('#internal_report_affects');
	if(!affectsEl.length){
		return;
	}

	const productSection = $('[data-capa-product-section]');
	const supplierSection = $('[data-capa-supplier-section]');
	const articleFields = [
		productSection,
		supplierSection
	];
	const productSelectClass = '.capa-product-select';
	const quantityAffected = $('#quantity_affected_items');
	const internalDescription = $('#internal_report_description');
	const deviationTypes = $('#deviation_types');
	const deviationOther = $('#deviation_other');
	const deviationProcesses = $('[data-capa-deviation-processes]');
	const rootCauseMethod = $('#root_cause_method');
	const rootCauseMethodOther = $('#root_cause_method_other');
	const correctionExtension = $('#correction_extension_needed');
	const correctionRationale = $('#correction_extension_rationale');
	const correctiveExtension = $('#corrective_action_extension_needed');
	const correctiveRationale = $('#corrective_action_extension_rationale');

	const toggleGroup = (field, show) => {
		if(!field.length){
			return;
		}
		const isSection = field.is('[data-capa-product-section], [data-capa-supplier-section], [data-capa-order-field]');
		const group = isSection || field.hasClass('form-group') ? field : field.closest('.form-group');
		if(show){
			group.removeClass('d-none');
		}else{
			group.addClass('d-none');
		}
	};

	const toggleInternalReportFields = () => {
		const value = affectsEl.val();
		const showArticle = value === 'article';
		const showOther = value === 'other';

		articleFields.forEach((field) => toggleGroup(field, showArticle));
		toggleGroup(internalDescription, showOther);
	};

	const toggleDeviationOther = () => {
		toggleGroup(deviationOther, deviationTypes.val() === 'other');
	};

	const toggleDeviationProcesses = () => {
		const value = deviationTypes.val();
		toggleGroup(deviationProcesses, value !== null && value !== '');
	};

	const toggleRootCauseOther = () => {
		toggleGroup(rootCauseMethodOther, rootCauseMethod.val() === 'other');
	};

	const toggleCorrectionRationale = () => {
		toggleGroup(correctionRationale, correctionExtension.is(':checked'));
	};

	const toggleCorrectiveRationale = () => {
		toggleGroup(correctiveRationale, correctiveExtension.is(':checked'));
	};

	const getQuantityInputs = () => {
		return $(`${productSelectClass}`).map((index, element) => {
			const row = $(element).closest('.main-row');
			return row.find('input[name$="[quantity]"]').get(0);
		}).get().filter(Boolean);
	};

	let syncingQuantity = false;
	const syncQuantityAffected = (force = false) => {
		if(!quantityAffected.length){
			return;
		}
		if(!force && quantityAffected.data('manual')){
			return;
		}

		let sum = 0;
		let hasValue = false;

		getQuantityInputs().forEach((input) => {
			const raw = $(input).val();
			if(raw === null || raw === undefined || raw === ''){
				return;
			}
			const normalized = raw.toString().replace(',', '.');
			const value = parseFloat(normalized);
			if(Number.isNaN(value)){
				return;
			}
			hasValue = true;
			sum += value;
		});

		syncingQuantity = true;
		if(hasValue && sum > 0){
			quantityAffected.val(sum);
		}else{
			quantityAffected.val('');
		}
		syncingQuantity = false;
	};

	const bindQuantityEvents = () => {
		$(document).off('input.capa-quantity change.capa-quantity', 'input[name$="[quantity]"]');
		$(document).on('input.capa-quantity change.capa-quantity', 'input[name$="[quantity]"]', () => {
			syncQuantityAffected();
		});

		if(quantityAffected.length){
			quantityAffected.off('input.capa-total change.capa-total').on('input.capa-total change.capa-total', () => {
				if(!syncingQuantity){
					quantityAffected.data('manual', true);
				}
			});
		}
	};

	const initSupplierHandler = () => {
		const supplierSelect = $('[data-function="supplier-handler"]');
		if(!supplierSelect.length){
			return;
		}

		supplierSelect.unbind('change.capa-supplier-handler').bind('change.capa-supplier-handler', function(){
			$('[data-id="supplier_email"]').val('');
			$('[data-id="prrc_clinic_email"]').val('');
			$('[data-id="prrc_clinic_phone"]').val('');
			$('[data-id="supplier_ch_rep"]').val('');
			$('[data-id="supplier_ch_rep_number"]').val('');
			const linkedSupplierFields = $('[data-id="supplier_email"], [data-id="prrc_clinic_email"], [data-id="prrc_clinic_phone"], [data-id="supplier_ch_rep"], [data-id="supplier_ch_rep_number"]');
			linkedSupplierFields.prop('disabled', false);

			const value = $(this).val();
			if(value === null || value === undefined || !/^\d+$/.test(value.toString())){
				return;
			}

			getPrrcInfo(value, (data) => {
				if(data.id){
					$('[data-id="supplier_email"]').val(data.email_security);
					$('[data-id="prrc_clinic_email"]').val(data.important_contact_email);
					$('[data-id="prrc_clinic_phone"]').val(data.important_contact_phone);
					$('[data-id="supplier_ch_rep"]').val(data.ch_rep);
					$('[data-id="supplier_ch_rep_number"]').val(data.ch_rep_number);
				}
			});
		});
	};

	const initProductPrototype = () => {
		addNewPrototype('add-new-prototype-product', () => {
			initSelect2();
			bindProductSelectEvents();
			bindQuantityEvents();
			const newSelect = $(productSelectClass).last();
			if(newSelect.length){
				syncSupplierFromProduct(newSelect);
				populateProductDetails(newSelect);
			}
			syncQuantityAffected();
		}, () => {
			syncQuantityAffected();
		});
	};

	const getProductMeta = (select) => {
		const raw = select.data('product-meta') || select.attr('data-product-meta');
		if(!raw){
			return {};
		}
		if(typeof raw === 'object'){
			return raw;
		}
		try{
			return JSON.parse(raw);
		}catch(error){
			return {};
		}
	};

	const syncSupplierFromProduct = (select) => {
		const productId = select.val();
		if(!productId){
			return;
		}
		const meta = getProductMeta(select);
		const supplierId = meta ? meta[productId] : null;
		if(!supplierId){
			return;
		}
		const supplierSelect = $('#supplier');
		if(!supplierSelect.length){
			return;
		}
		if(supplierSelect.val() != supplierId){
			supplierSelect.val(supplierId).trigger('change');
		}
	};

	const populateProductDetails = (select) => {
		const productId = select.val();
		if(!productId){
			return;
		}

		const row = select.closest('.main-row');
		const addressId = $('#address_id').val();

		if(!Number.isInteger(parseInt(addressId))){
			return;
		}
		if(!Number.isInteger(parseInt(productId))){
			return;
		}

		axios.get(`/api/product/${productId}/get-info-for-report?address_id=${addressId}`)
			.then((response) => {
				const data = response.data || {};
				if(!data || data === ''){
					return;
				}

				if(data.supplier_id){
					const supplierSelect = $('#supplier');
					if(supplierSelect.length){
						supplierSelect.val(data.supplier_id).trigger('change');
					}
				}

				const batchLots = [{id: '', text: "=== auswählen ==="}];
				if(data.batch_lots){
					Object.keys(data.batch_lots).forEach(batch_lot => batchLots.push({id: batch_lot, text: batch_lot}));
				}
				updateOptionsSelect2(row.find('[data-id="batch_lot"]'), batchLots);

				const serialNumbers = [{id: '', text: "=== auswählen ==="}];
				if(data.serial_numbers){
					Object.keys(data.serial_numbers).forEach(serial_number => serialNumbers.push({id: serial_number, text: serial_number}));
				}
				updateOptionsSelect2(row.find('[data-id="serial_number"]'), serialNumbers);
			});
	};

	const bindProductSelectEvents = () => {
		$(document).off('change.capa-product select2:select.capa-product select2:clear.capa-product', productSelectClass);
		$(document).on('change.capa-product select2:select.capa-product select2:clear.capa-product', productSelectClass, function(){
			const select = $(this);
			syncSupplierFromProduct(select);
			populateProductDetails(select);
			syncQuantityAffected();
		});
	};

	affectsEl.unbind('change.capa-affects-handler').bind('change.capa-affects-handler', toggleInternalReportFields);
	deviationTypes.unbind('change.capa-deviation-handler').bind('change.capa-deviation-handler', toggleDeviationOther);
	deviationTypes.unbind('change.capa-deviation-processes').bind('change.capa-deviation-processes', toggleDeviationProcesses);
	rootCauseMethod.unbind('change.capa-root-cause-handler').bind('change.capa-root-cause-handler', toggleRootCauseOther);
	correctionExtension.unbind('change.capa-correction-extension-handler').bind('change.capa-correction-extension-handler', toggleCorrectionRationale);
	correctiveExtension.unbind('change.capa-corrective-extension-handler').bind('change.capa-corrective-extension-handler', toggleCorrectiveRationale);

	toggleInternalReportFields();
	toggleDeviationOther();
	toggleDeviationProcesses();
	toggleRootCauseOther();
	toggleCorrectionRationale();
	toggleCorrectiveRationale();

	bindProductSelectEvents();
	bindQuantityEvents();

	$(productSelectClass).each(function(){
		const select = $(this);
		syncSupplierFromProduct(select);
		populateProductDetails(select);
	});
	if(!quantityAffected.val()){
		syncQuantityAffected(true);
	}
	initSupplierHandler();
	initProductPrototype();
	initStepGating({
		containerSelector: '[data-capa-step]',
		messageSelector: '.capa-step-message',
		disabledClass: 'capa-step-disabled',
		eventNamespace: 'capa-step'
	});
	initProductSelection();
};

export default initCapaReportForm;
